import { useEffect, useState } from "react";
import { MapPin, Bike } from "lucide-react";

/**
 * MapMock — a lightweight simulated map with a moving driver marker.
 * Renders an SVG street grid + route path with an animated bike icon.
 */
export default function MapMock({ height = 260, animated = true, driverName = "Kwesi", dark = false }) {
  const [t, setT] = useState(0);

  useEffect(() => {
    if (!animated) return;
    const id = setInterval(() => setT((prev) => (prev + 1) % 100), 120);
    return () => clearInterval(id);
  }, [animated]);

  // Bezier-ish path we sample from
  const pathPoints = [
    [40, 200], [110, 160], [170, 170], [230, 130], [300, 120], [370, 90], [430, 70], [480, 50],
  ];
  const idx = Math.floor((t / 100) * (pathPoints.length - 1));
  const [x, y] = pathPoints[idx] || pathPoints[0];

  return (
    <div
      className={`relative overflow-hidden ${dark ? "map-bg-dark" : "map-bg"}`}
      style={{ height, borderRadius: typeof height === "number" ? "1rem" : undefined }}
      data-testid="map-mock"
    >
      <svg viewBox="0 0 500 260" preserveAspectRatio="xMidYMid slice" className="absolute inset-0 w-full h-full">
        {/* Route line */}
        <path
          d="M40,200 C110,160 170,180 230,130 S 370,80 480,50"
          fill="none"
          stroke={dark ? "#18B45B" : "#0F8E44"}
          strokeWidth="4"
          strokeLinecap="round"
          className="route-path"
        />
        {/* Restaurant start */}
        <circle cx="40" cy="200" r="8" fill="#F2C94C" stroke={dark ? "#0A0A0A" : "white"} strokeWidth="3" />
        {/* Destination */}
        <circle cx="480" cy="50" r="10" fill="#18B45B" stroke={dark ? "#0A0A0A" : "white"} strokeWidth="3" />
      </svg>

      {/* Driver marker */}
      <div
        className="absolute w-10 h-10 rounded-full bg-eatup-green text-white flex items-center justify-center shadow-lg pulse-ring relative"
        style={{ left: `calc(${(x / 500) * 100}% - 20px)`, top: `calc(${(y / 260) * 100}% - 20px)`, transition: "left 200ms linear, top 200ms linear" }}
      >
        <Bike className="w-5 h-5" />
      </div>

      {/* Labels */}
      <div className={`absolute bottom-3 left-3 ${dark ? "bg-white/10 text-white" : "bg-white/90 text-eatup-charcoal"} backdrop-blur rounded-full px-3 py-1.5 text-xs font-semibold flex items-center gap-2`}>
        <MapPin className="w-3.5 h-3.5 text-eatup-green" />
        {driverName} · en route
      </div>
    </div>
  );
}
